
import { DataEntryDynamicPageButtonsAgent } from '@cs/performance-manager/data-entry';

export class CustomerDynamicButtonsAgent extends DataEntryDynamicPageButtonsAgent {

	setupButtons(): void {
		super.setupButtons();
	}
}